var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMessaging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2485",
    "data-name": "Group 2485",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.111,
    height: 42.127,
    viewBox: "0 0 42.111 42.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_915",
    "data-name": "Rectangle 915",
    width: 42.111,
    height: 42.127,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M20.891.014A20.95,20.95,0,0,1,41.632,16.756a20.379,20.379,0,0,1-5.046,18.466A20.281,20.281,0,0,1,23.95,41.9a20.66,20.66,0,0,1-12.769-2.17,1.2,1.2,0,0,0-.96-.088c-2.168.622-4.344,1.219-6.509,1.85A2.468,2.468,0,0,1,1.1,40.9a2.464,2.464,0,0,1-.568-2.628q.956-3.246,1.94-6.484a1.174,1.174,0,0,0-.078-.959A20.168,20.168,0,0,1,.036,22.439a20.654,20.654,0,0,1,7.119-17.2,20.433,20.433,0,0,1,10.71-5A14.6,14.6,0,0,1,20.891.014M38.97,20.894a12.3,12.3,0,0,0-.213-2.686,17.614,17.614,0,0,0-6.1-10.86A17.528,17.528,0,0,0,18.349,3.221,17.345,17.345,0,0,0,7.135,9.467a17.638,17.638,0,0,0-4.08,13.678,16.73,16.73,0,0,0,2,6.328,4.017,4.017,0,0,1,.314,3.306c-.531,1.687-1.025,3.385-1.534,5.079-.038.127-.153.277-.044.383s.26-.017.383-.053c1.652-.49,3.318-.94,4.944-1.5a4.311,4.311,0,0,1,3.6.341,17.6,17.6,0,0,0,11.362,1.739A18.014,18.014,0,0,0,38.97,20.894",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M153.347,163.832a2.5,2.5,0,1,1,2.491-2.509,2.509,2.509,0,0,1-2.491,2.509",
    transform: "translate(-132.384 -139.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M87.174,161.351a2.463,2.463,0,0,1,2.467-2.517,2.5,2.5,0,1,1-.009,5,2.465,2.465,0,0,1-2.458-2.482",
    transform: "translate(-76.508 -139.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M219.577,161.326a2.465,2.465,0,0,1-2.48,2.507,2.5,2.5,0,1,1,.032-5,2.463,2.463,0,0,1,2.448,2.492",
    transform: "translate(-188.334 -139.4)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessaging);
export default __webpack_public_path__ + "static/media/icon_messaging.ff00e43108e549780becd24e77256132.svg";
export { ForwardRef as ReactComponent };